import Button from "src/components/button/Button";
import SelectorWrapper from "src/components/selectorwrapper/SelectorWrapper";
import OptionsProps from "src/components/streaming/findsomethingtostream/OptionsProps";
import { SControls, SFilterBlock, SLabelledCheck, SScrollContainer } from "src/components/streaming/findsomethingtostream/OptionsStyles";
import { STREAMING_GENRES } from "src/lib/streaming/FindSomethingToStreamFilter";
import { uniq } from "lodash";
import { Dispatch, SetStateAction, useState } from "react";


//#region [Component]
export default function OptionsGenre({ filterDispatch, filterState }: OptionsProps) {
	const [selectedGenres, setSelectedGenres] = useState(filterState.genres);

	return <SelectorWrapper onClose={() => filterDispatch({ type: "hideOptions" })} heading="Sjanger">
		<SScrollContainer>
			<SFilterBlock>
				<SLabelledCheck value="Alle"
					selected={selectedGenres.length === 0}
					selectionCallback={() => setSelectedGenres([])}
				/>

				{STREAMING_GENRES.map(genre => <SLabelledCheck
					key={genre}
					value={genre}
					selected={selectedGenres.includes(genre)}
					selectionCallback={(isSelected) => selectGenre(genre, isSelected, setSelectedGenres, selectedGenres)}
				/>)}
			</SFilterBlock>
		</SScrollContainer>
		<SControls>
			<Button text="Vis" onClick={() => filterDispatch({ type: "setGenres", genres: selectedGenres })} />
			<Button text="Avbryt" onClick={() => filterDispatch({ type: "hideOptions" })} />
		</SControls>
	</SelectorWrapper>;
}
//#endregion

//#region [Other]
function selectGenre(genre: string, isSelected: boolean, setSelectedGenres: Dispatch<SetStateAction<string[]>>, selectedGenres: string[]) {
	if (isSelected) {
		setSelectedGenres(uniq([...selectedGenres, genre]));
	} else {
		setSelectedGenres(selectedGenres.filter(g => g !== genre));
	}
}
//#endregion
